import { Injectable } from '@angular/core';
import { DateUtilService } from '../utilities/date.util.service';
@Injectable({
    providedIn: 'root'
})
export class DaterenderService {
    constructor(private readonly dateUtil: DateUtilService) { }
    
    render_data(date: Date): string {
        return this.dateUtil.dateFormat(new Date(date), 'YYYY-MM-DD');
    }
}
